/* eslint-disable jsx-a11y/anchor-is-valid */
import { Route } from "routes/_authenticated/app.kunder.$customerId.facility.$facilityId.index";

import { PageLoader } from "components/PageLoader";

import { getFacility } from "api/facility.api";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "components/PageHeader";

import { TabMenu } from "../uppdrag/TabMenu";
import { FacilitySeparatorListTab } from "./FacilitySeparatorListTab";
import { FacilityUppdragListTab } from "./FacilityUppdragListTab";
import { FacilityDetailsTab } from "./FacilityDetailsTab";
import { PortalAccessEmailSection } from "../customer/PortalAccessEmailSection";
import { ErrorScreen } from "components/ErrorScreen";
import { useMemo, useEffect } from "react";
import { scrollToTop } from "helpers/scroll";
import { useHasRightsForFeature } from "api/company.api";
import { OperatorPrivilege } from "types/company.type";

export enum FacilityPageTab {
  Overview = "oversikt",
  Separators = "objekt",
  Assignments = "uppdrag",
  // Kundportal = "kundportal",
}

const tabs = [
  { label: "Översikt", value: FacilityPageTab.Overview },
  { label: "Objekt", value: FacilityPageTab.Separators },
  {
    label: "Uppdrag",
    value: FacilityPageTab.Assignments,
  },
  // {
  //   label: "Kundportal",
  //   value: FacilityPageTab.Kundportal,
  // },
];

export const FacilityPage = () => {
  const { facilityId } = Route.useParams();
  const search = Route.useSearch();
  const facilityIdNum: string = facilityId || "-1";

  // GET facility
  const {
    data: facility,
    isLoading,
    isError,
  } = useQuery({ ...getFacility(Number(facilityIdNum)) });

  const currentTab = search.tab ?? FacilityPageTab.Overview;

  const tabMenuItems = useMemo(
    () =>
      tabs.map((tab) => ({
        label: tab.label,
        value: tab.value,
        isActive: currentTab === tab.value,
        link: {
          search: { tab: tab.value },
        },
      })),
    [currentTab],
  );

  useEffect(() => {
    if (facility) {
      document.title = facility.name;
    }
  }, [facility]);

  useEffect(() => {
    scrollToTop();
  }, [currentTab]);

  const canViewCustomerPage = useHasRightsForFeature(
    OperatorPrivilege.ViewCustomer,
  );

  if (isLoading) {
    return <PageLoader />;
  }

  if (isError || !facility) {
    return <ErrorScreen />;
  }

  return (
    <div className="max-w-7xl">
      <PageHeader
        header={facility.name}
        breadCrumbList={[
          {
            label: facility.customer.name,
            link: canViewCustomerPage
              ? {
                  to: "/app/kunder/$customerId",
                  params: { customerId: facility.customer.id.toString() },
                }
              : undefined,
            iconType: "customer",
          },
        ]}
        iconType="facility"
      />
      <TabMenu items={tabMenuItems} />
      {currentTab === FacilityPageTab.Overview && (
        <FacilityDetailsTab facility={facility} />
      )}
      {currentTab === FacilityPageTab.Separators && (
        <FacilitySeparatorListTab facility={facility} />
      )}
      {currentTab === FacilityPageTab.Assignments && (
        <FacilityUppdragListTab facility={facility} />
      )}
      {/* {currentTab === FacilityPageTab.Kundportal && (
        <PortalAccessEmailSection
          customerId={facility.customer.id}
          facilityId={Number(facilityIdNum)}
        />
      )} */}
    </div>
  );
};
